module.exports = __webpack_public_path__ + "static/media/arrow-icon-2.f43e8007.svg";